// extracted by mini-css-extract-plugin
export default {"button":"button___nOI74","hidden":"hidden___Dil38"};